export default __webpack_public_path__ + "assets/thumbnail.d588b650.jpg";